import { useUser } from '~/modules/auth/hooks/useUser';

export const useIsExternalUser = () => {
  const { isInternal } = useUser();

  return !isInternal;
};
